<template>
  <button :disabled="disabled" @click="clickLetter(letter)" :style="buttonStyle">
    {{ letter }}
  </button>
</template>

<script>
export default {
  props: {
    letter: String,
    active: Boolean,
    dense: Boolean
  },
  data() {
    return {
      disabled: false
    };
  },
  computed: {
    buttonStyle() {
      return {
        color: this.active ? "gray" : "lightgray",
        width: this.dense ? "1.7rem" : "2.5rem",
        height: this.dense ? "1.7rem" : "2.5rem",
        lineHeight: this.dense ? "1.8rem" : "2.2rem"
      };
    }
  },
  methods: {
    clickLetter(letter) {
      if (this.active) {
        this.disabled = true;
        this.$emit("keypress", letter);
      }
    },
    reset() {
      this.disabled = false;
    }
  }
};
</script>

<style scoped lang="scss">
.letter {
  background-color: rgba(255, 255, 255, 0.75);
  font-weight: bold;
  font-size: 1.2rem;
  // color: gray;
  // text-shadow: $white 1px 1px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.025);
  text-transform: uppercase;
  // width: 2.5rem;
  // height: 2.5rem;

  margin: 0 0.125rem 0.24rem;
  position: relative;
  border: 0;

  // @include breakpoint-sm {
  //   width: 2.5rem;
  //   height: 2.5rem;
  //   line-height: 2.5rem;
  //   margin: 0 0.25rem 0.5rem;
  // }

  // @include breakpoint-md {
  //   width: 3rem;
  //   height: 3rem;
  //   line-height: 3rem;
  //   margin: 0 0.25rem 0.5rem;
  // }

  &:nth-child(n + 11) {
    order: 1;
  }

  &:nth-child(n + 20) {
    order: 2;
  }

  &:hover {
    background: lightgreen;
    cursor: pointer;
  }

  &:active {
    top: 1px;
  }

  &:disabled {
    background-color: lightgray;
  }
}
</style>
